/*!

=========================================================
* Argon Design System React - v1.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes
// import classnames from "classnames";
import { Link } from "react-router-dom";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardImg,
  Container,
  Row,
  Col
} from "reactstrap";

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import Hero from "../IndexSections/Hero.js";
import SimpleFooter from "components/Footers/SimpleFooter.js";

class Landing extends React.Component {
  constructor(props) {
    super(props);
    // create a ref to store the textInput DOM element
    this.state = {
      email: '',
      organization: '',
      comments: '',
    };
    //this.submitToContactAPI = this.submitToContactAPI.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  state = {};
  componentDidMount() {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;
  }

  handleChange = (event) => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
    });
  };

  submitToContactAPI(e) {
    e.preventDefault();
    var organization = this.state.organization;
    var email = this.state.email;
    var message = this.state.comments;
    console.log(this.state.comments);
    var data = {
       organization : organization,
       email : email,
       message : message
     };

    fetch("/api/info", {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    }).then((response) => {
      alert("Thanks for reaching out! Your message is on its way!");
      this.setState({
        email: '',
        organization: '',
        comments: '',
      });
    }).catch((error) => {
      alert('Sorry something went wrong and we were unable to send your message. Feel free to email us at <a href="mailto: contact@hichisp.com">contact@hichisp.com</a>');
    });
  }

  render() {
    return (
      <>
        <DemoNavbar />
        <main ref="main">
        <Hero />
          <section className="section section-lg pt-0">
            <Container>
              <Row className="justify-content-center text-center mb-lg">
                <Col lg="8">
                  <h2 className="display-3">Data Analytics & Device Connectivity</h2>
                  <p className="lead text-muted">
                    Comprehensive data analytics and device connectivity solutions that transform 
                    raw data into actionable insights while seamlessly integrating IoT devices 
                    across industrial, commercial, and residential environments.
                  </p>
                </Col>
              </Row>
              <Row className="row-grid">
                <Col lg="4">
                  <Card className=" shadow border-0 h-100">
                    <CardBody className="py-5">
                      <div className="icon icon-shape icon-shape-info rounded-circle mb-4">
                        <i className="fa fa-line-chart" />
                      </div>
                      <h5 className="text-info">Data Analytics</h5>
                      <p className="description mt-3">
                        Advanced analytics platform that transforms raw data into actionable insights. 
                        Real-time processing, predictive modeling, and intelligent dashboards.
                      </p>
                      <ul className="list-unstyled mt-3">
                        <li className="py-1">
                          <i className="fa fa-check text-success mr-2" />
                          Real-time data processing
                        </li>
                        <li className="py-1">
                          <i className="fa fa-check text-success mr-2" />
                          Predictive analytics
                        </li>
                        <li className="py-1">
                          <i className="fa fa-check text-success mr-2" />
                          Custom dashboards
                        </li>
                        <li className="py-1">
                          <i className="fa fa-check text-success mr-2" />
                          AI-powered insights
                        </li>
                      </ul>
                      <Button
                        className="btn-round mt-4"
                        color="info"
                        to="/data-analytics"
                        tag={Link}
                      >
                        Explore Data Analytics
                      </Button>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="4">
                  <Card className=" shadow border-0 h-100">
                    <CardBody className="py-5">
                      <div className="icon icon-shape icon-shape-primary rounded-circle mb-4">
                        <i className="fa fa-industry" />
                      </div>
                      <h5 className="text-primary">Industrial Monitoring</h5>
                      <p className="description mt-3">
                        Connected sensors and monitoring systems designed for industrial environments. 
                        Track equipment performance, environmental conditions, and operational efficiency.
                      </p>
                      <ul className="list-unstyled mt-3">
                        <li className="py-1">
                          <i className="fa fa-check text-success mr-2" />
                          Equipment monitoring
                        </li>
                        <li className="py-1">
                          <i className="fa fa-check text-success mr-2" />
                          Environmental tracking
                        </li>
                        <li className="py-1">
                          <i className="fa fa-check text-success mr-2" />
                          Predictive maintenance
                        </li>
                        <li className="py-1">
                          <i className="fa fa-check text-success mr-2" />
                          Performance analytics
                        </li>
                      </ul>
                      <Button
                        className="btn-round mt-4"
                        color="primary"
                        to="/industrial"
                        tag={Link}
                      >
                        Explore Industrial Monitoring
                      </Button>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="4">
                  <Card className=" shadow border-0 h-100">
                    <CardBody className="py-5">
                      <div className="icon icon-shape icon-shape-success rounded-circle mb-4">
                        <i className="fa fa-home" />
                      </div>
                      <h5 className="text-success">Home Connectivity</h5>
                      <p className="description mt-3">
                        Smart home integration and device connectivity solutions. 
                        Seamlessly connect and control all your smart devices from one platform.
                      </p>
                      <ul className="list-unstyled mt-3">
                        <li className="py-1">
                          <i className="fa fa-check text-success mr-2" />
                          Device integration
                        </li>
                        <li className="py-1">
                          <i className="fa fa-check text-success mr-2" />
                          Smart automation
                        </li>
                        <li className="py-1">
                          <i className="fa fa-check text-success mr-2" />
                          Voice control
                        </li>
                        <li className="py-1">
                          <i className="fa fa-check text-success mr-2" />
                          Energy monitoring
                        </li>
                      </ul>
                      <Button
                        className="btn-round mt-4"
                        color="success"
                        to="/home"
                        tag={Link}
                      >
                        Explore Home Connectivity
                      </Button>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="section bg-white">
            <Container>
              <Row className="row-grid align-items-center">
                <Col md="6">
                  <Card className="bg-default shadow border-0">
                    <CardImg
                      alt="..."

                      src={require("assets/img/theme/hub.jpg")}

                      top
                    />
                    <blockquote className="card-blockquote">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="svg-bg"
                        preserveAspectRatio="none"
                        viewBox="0 0 583 95"
                      >
                        <polygon
                          className="fill-default"
                          points="0,52 583,95 0,95"
                        />
                        <polygon
                          className="fill-default"
                          opacity=".2"
                          points="0,42 583,95 683,0 0,95"
                        />
                      </svg>
                      <h4 className="display-3 font-weight-bold text-white">

                        Connecting all your devices to one smart hub
                      </h4>
                      <p className="lead text-italic text-white">
                      A Chisp hub powers your entire site and monitors with the latest AI features

                      </p>
                    </blockquote>
                  </Card>
                </Col>
                <Col md="6">
                  <div className="pl-md-5">
                    <div className="icon icon-lg icon-shape icon-shape-warning shadow rounded-circle mb-4">
                      <i className="ni ni-button-power" />
                    </div>
                    <h3>Our Story</h3>
                    <p className="lead">
                    How many times have disconnected systems forced you into guesswork? 
                    How often have you missed critical insights because your data lives in silos? 
                    Are you confident your monitoring and analytics systems are delivering the intelligence you need to make informed decisions?
                    </p>
                    <p>
                    Imagine walking into your facility—whether it's a factory floor, warehouse, smart home, or remote site—and seeing every sensor, camera, and device connected and working together. 
                    No more blind spots. No more digging through multiple systems for insights. Just a clear, unified view of your operations with intelligent analytics driving proactive decisions.
                    </p>
                    <p>
                    Chisp was founded on the belief that monitoring and analytics should be both powerful and accessible. With the Chisp Hub, we unify your IoT ecosystem, transform raw data into actionable insights, provide intelligent monitoring across all environments, and deliver real-time analytics through a single, intuitive dashboard. <strong>One platform, infinite insight, intelligent monitoring.</strong>
                    </p>
                    {/* <a
                     className="font-weight-bold text-warning mt-5"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                    >
                    /A beautiful UI Kit for impactful websites
                    </a> */}

                  </div>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="section pb-0 bg-gradient-default" style={{
            background: 'linear-gradient(135deg, #232b4d 0%, #2d365f 100%)',
            padding: '0',
            paddingTop: '2.5rem',
            paddingBottom: '2.5rem',
            fontFamily: 'Inter, sans-serif'
          }}>
            <Container>
              <Row className="align-items-center flex-column-reverse flex-md-row" style={{ minHeight: '520px', padding: '1rem 0 2rem 0' }}>
                <Col md="6" className="d-flex flex-column justify-content-center align-items-center align-items-md-start" style={{gap: '2.5rem'}}>
                  <div style={{ width: '100%', maxWidth: 520, margin: '0 auto', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <h2 style={{ color: '#fff', fontSize: '2.3rem', fontWeight: 700, marginBottom: '0.5rem', letterSpacing: '-1px', lineHeight: 1.1, textAlign: 'center' }}>Chisp IoT Dashboard</h2>
                    <h5 style={{ color: '#B2B7FF', fontWeight: 400, marginBottom: '2rem', fontSize: '1.15rem', letterSpacing: '-0.5px', textAlign: 'center' }}>Real-Time Monitoring & AI-Powered Insights</h5>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', width: '100%', alignItems: 'center' }}>
                      <div className="card bg-white shadow">
                        <div className="card-body">
                          <div className="d-flex align-items-center">
                            <div className="icon icon-shape bg-gradient-primary text-white rounded-circle mr-3">
                              <i className="ni ni-chart-bar-32" />
                            </div>
                            <div>
                              <h6 className="text-primary text-uppercase ls-1 mb-1">Real-Time Alerts</h6>
                              <p className="text-sm mb-0">
                                Instantly receive notifications for important events, such as human detection in hazard zones.<br />
                                <span className="text-primary font-weight-bold">Stay informed, stay secure</span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card bg-white shadow">
                        <div className="card-body">
                          <div className="d-flex align-items-center">
                            <div className="icon icon-shape bg-gradient-warning text-white rounded-circle mr-3">
                              <i className="ni ni-settings" />
                            </div>
                            <div>
                              <h6 className="text-warning text-uppercase ls-1 mb-1">Device Management</h6>
                              <p className="text-sm mb-0">
                                <span className="font-weight-bold">Unified Control:</span> Manage all your connected devices from a single dashboard.<br />
                                <span className="font-weight-bold">AI-Powered Insights:</span> Leverage advanced analytics and AI to optimize your site's safety and efficiency.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col md="6" className="d-flex justify-content-center align-items-center mb-5 mb-md-0" style={{ minHeight: 400 }}>
                  <img
                    alt="Chisp IoT Dashboard Preview"
                    src={require("assets/img/theme/Dashboard.png")}
                    style={{
                      width: "100%",
                      maxWidth: "700px",
                      height: "auto",
                      borderRadius: "1.5rem",
                      boxShadow: "0 8px 32px rgba(44,62,80,0.18)",
                      background: "rgba(255,255,255,0.01)",
                      margin: "2rem 0",
                      border: '1.5px solid rgba(255,255,255,0.18)'
                    }}
                  />
                </Col>
              </Row>
            </Container>
            {/* SVG separator */}
            <div className="separator separator-bottom separator-skew zindex-100">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
                version="1.1"
                viewBox="0 0 2560 100"
                x="0"
                y="0"
              >
                <polygon
                  className="fill-white"
                  points="2560 0 2560 100 0 100"
                />
              </svg>
            </div>
          </section>
          <section className="section section-lg bg-gradient-default">
            <Container>
              <Row className="justify-content-center text-center mb-lg">
                <Col lg="8">
                  <h2 className="display-3 text-white">Platform Capabilities</h2>
                  <p className="lead text-white">
                    Our comprehensive platform combines advanced analytics with seamless device 
                    connectivity to deliver intelligent insights across all your systems.
                  </p>
                </Col>
              </Row>
              <Row className="row-grid">
                <Col lg="3" md="6">
                  <div className="text-center">
                    <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary mb-4">
                      <i className="fa fa-database text-primary" />
                    </div>
                    <h5 className="text-white">Data Processing</h5>
                    <p className="text-white">
                      Real-time data ingestion, processing, and transformation 
                      from multiple sources with enterprise-grade reliability.
                    </p>
                  </div>
                </Col>
                <Col lg="3" md="6">
                  <div className="text-center">
                    <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary mb-4">
                      <i className="fa fa-sitemap text-primary" />
                    </div>
                    <h5 className="text-white">Device Integration</h5>
                    <p className="text-white">
                      Seamless connectivity across IoT devices, sensors, and systems 
                      with support for standard protocols and APIs.
                    </p>
                  </div>
                </Col>
                <Col lg="3" md="6">
                  <div className="text-center">
                    <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary mb-4">
                      <i className="fa fa-line-chart text-primary" />
                    </div>
                    <h5 className="text-white">Analytics & Insights</h5>
                    <p className="text-white">
                      Advanced analytics, machine learning, and AI-powered insights 
                      that transform data into actionable intelligence.
                    </p>
                  </div>
                </Col>
                <Col lg="3" md="6">
                  <div className="text-center">
                    <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary mb-4">
                      <i className="fa fa-shield text-primary" />
                    </div>
                    <h5 className="text-white">Secure Connectivity</h5>
                    <p className="text-white">
                      Enterprise-grade security with encryption, authentication, 
                      and compliance features built into every connection.
                    </p>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="section bg-white" style={{paddingTop: '2.5rem', paddingBottom: '2.5rem'}}>
            <Container>
              <Row className="text-center justify-content-center">
                <Col lg="10">
                  <h2 className="display-3">How does it work?</h2>
                  <p className="lead text-muted">
                    Chisp hub seamlessly connects all your devices together and comes packaged with the latest AI features.
                  </p>
                </Col>
              </Row>
              <Row className="row-grid mt-5">
                <Col lg="4">
                <div className="pt-4 text-center">
                  <div className="icon icon-lg icon-shape bg-gradient-primary shadow rounded-circle text-white mb-4">
                    <i className="ni ni-zoom-split-in" />
                  </div>
                  <h4 className="mt-3">Observe</h4>
                  <p className="text-muted mt-3">
                    Detect anomalies such as motion or unexpected activity
                  </p>
                </div>
                </Col>
                <Col lg="4">
                  <div className="pt-4 text-center">
                    <div className="icon icon-lg icon-shape bg-gradient-success shadow rounded-circle text-white mb-4">
                      <i className="ni ni-atom" />
                    </div>
                    <h4 className="mt-3">Verify</h4>
                    <p className="text-muted mt-3">
                      Run advanced AI models to verify the anomaly and reduce false alarms
                    </p>
                  </div>
                </Col>
                <Col lg="4">
                  <div className="pt-4 text-center">
                    <div className="icon icon-lg icon-shape bg-gradient-warning shadow rounded-circle text-white mb-4">
                      <i className="ni ni-bell-55" />
                    </div>
                    <h4 className="mt-3">Act</h4>
                    <p className="text-muted mt-3">
                      Instantly notify or sound the alarm to keep your site secure
                    </p>
                  </div>
                </Col>
              </Row>
            </Container>
            {/* SVG separator */}
            <div className="separator separator-bottom separator-skew zindex-100">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
                version="1.1"
                viewBox="0 0 2560 100"
                x="0"
                y="0"
              >
                <polygon
                  className="fill-white"
                  points="2560 0 2560 100 0 100"
                />
              </svg>
            </div>
          </section>
          <section className="section section-lg bg-gradient-default">
            <Container className="pt-lg pb-300">
              <Row className="text-center justify-content-center">
                <Col lg="10">
                  <h2 className="display-3 text-white">Why Choose Chisp?</h2>
                  <p className="lead text-white">
                    Experience the difference of purpose-built data analytics and connectivity solutions 
                    designed for reliability, scalability, and intelligent automation.
                  </p>
                </Col>
              </Row>
              <Row className="row-grid mt-5">
                <Col lg="4">
                  <div className="text-center">
                    <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary mb-4">
                      <i className="fa fa-bar-chart text-primary" />
                    </div>
                    <h4 className="text-white mt-3">Data-Driven Insights</h4>
                    <p className="text-white mt-3">
                      Transform raw data into actionable intelligence with advanced analytics. 
                      Make informed decisions based on real-time insights and predictive modeling.
                    </p>
                  </div>
                </Col>
                <Col lg="4">
                  <div className="text-center">
                    <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary mb-4">
                      <i className="fa fa-sitemap text-primary" />
                    </div>
                    <h4 className="text-white mt-3">Universal Connectivity</h4>
                    <p className="text-white mt-3">
                      Connect any device, anywhere, with our flexible connectivity platform. 
                      Support for all major protocols and seamless integration capabilities.
                    </p>
                  </div>
                </Col>
                <Col lg="4">
                  <div className="text-center">
                    <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary mb-4">
                      <i className="fa fa-cogs text-primary" />
                    </div>
                    <h4 className="text-white mt-3">Intelligent Automation</h4>
                    <p className="text-white mt-3">
                      AI-powered automation that learns and adapts to your environment. 
                      Reduce manual tasks and optimize operations with intelligent systems.
                    </p>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
        </main>
        <SimpleFooter />
      </>
    );
  }
}

export default Landing;
